export default {
    primary: {
        base: '#0089BF',
        darken1: '#004A79',
    },
    secondary: {
        base: '#AAAAAA',
    },
    accent: {
        base: '#BE0443',
        darken1: '#8B0331',
    },
    info: {
        base: '#4CAFAB',
        darken1: '#1A817D',
    },
    error: {
        base: '#D62525',
    },
    success: {
        base: '#2FC156',
        darken1: '#05912A',
    },
    warning: {
        base: '#E5B900',
        darken1: '#DB8003',
    },
}
